import { ReactNode } from 'react';

import { Grid, GridProps, BoxProps, Box } from '@aircall/tractor-v2';

type GridLayoutProps = GridProps & {
  children: ReactNode;
};

/**
 * Grid Layout of 12 columns of equal width
 */
export function GridLayout({ gap = 's', children, ...rest }: GridLayoutProps) {
  return (
    <Grid gridTemplateColumns='repeat(12, 1fr)' gap={gap} gridAutoFlow='row' {...rest}>
      {children}
    </Grid>
  );
}

export type ColumnsCount = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type GridItemProps = Omit<BoxProps, 'gridColumn'> & {
  children: ReactNode;
  /** The number of columns that applys at all breakpoints */
  xs: ColumnsCount;
  /** The number of columns that applys if screen size is above 576px */
  sm?: ColumnsCount;
  /** The number of columns that applys if screen size is above 768px */
  md?: ColumnsCount;
  /** The number of columns that applys if screen size is above 992px */
  lg?: ColumnsCount;
  /** The number of columns that applys if screen size is above 1200px */
  xl?: ColumnsCount;
};

/**
 * Responsive Grid Item
 */
export function GridItem({ xs, sm, md, lg, xl, children, ...boxProps }: GridItemProps) {
  /* istanbul ignore next  */
  const gridColumns = {
    _: `span ${xs}`,
    sm: sm ? `span ${sm}` : undefined,
    md: md ? `span ${md}` : undefined,
    lg: lg ? `span ${lg}` : undefined,
    xl: xl ? `span ${xl}` : undefined,
  };

  return (
    <Box gridColumn={gridColumns} {...boxProps}>
      {children}
    </Box>
  );
}
